import { styled } from '@mui/material/styles';

export const Content = styled('div')(({ theme, $weight }) => ({
  fontSize: theme.fontSize.base,
  fontWeight: theme.fontWeight[$weight],
  overflowWrap: 'break-word',
  overflow: 'hidden',
  whiteSpace: 'pre-wrap'
}));

export const Label = styled('div')(({ theme, $weight }) => ({
  fontSize: theme.fontSize.base,
  fontWeight: theme.fontWeight[$weight]
}));

export const Container = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  overflow: 'hidden',
  [`& ${Content}`]: {
    marginTop: theme.spacing(1)
  }
}));
